var render, staticRenderFns
import script from "./ChartDoughnut.vue?vue&type=script&lang=js"
export * from "./ChartDoughnut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dc5a14",
  null
  
)

export default component.exports